import { render, staticRenderFns } from "./posCredit.vue?vue&type=template&id=5e8e2088&scoped=true&"
import script from "./posCredit.vue?vue&type=script&lang=js&"
export * from "./posCredit.vue?vue&type=script&lang=js&"
import style0 from "./posCredit.vue?vue&type=style&index=0&id=5e8e2088&prod&scoped=true&lang=css&"
import style1 from "./posCredit.vue?vue&type=style&index=1&id=5e8e2088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e2088",
  null
  
)

export default component.exports